import { SchemeSet, SchemeForm } from '@strength/domain';
import { Scheme } from './types';
import { v4 } from 'uuid';

export const getSchemeFromForm = (
  id: string,
  form: SchemeForm,
): Omit<Scheme, 'trainingType'> => {
  const { workouts, ...rest } = form;

  const sets: SchemeSet[] = workouts.flatMap((workout, workoutIndex) =>
    workout.sets.map((set, setIndex) => ({
      id: set.id,
      cycleIndex: workoutIndex,
      sessionIndex: 0,
      sortOrder: setIndex,
      metrics: set.metrics.map((metric) => ({
        ...metric,
        value: metric.input,
      })),
    })),
  );

  return {
    id,
    ...rest,
    sets,
    focuses: form.focusIds.map((id, index) => ({
      id: v4(),
      focusId: id,
      sortOrder: index,
    })),
  };
};

export const filterSchemes = ({
  schemes,
  trainingTypeId,
  searchTerm,
  focusIds,
  numOfCycles,
}: {
  schemes: Scheme[];
  trainingTypeId?: string;
  searchTerm: string;
  focusIds: string[];
  numOfCycles?: number;
}) => {
  const search = searchTerm.toLowerCase();

  return schemes.filter((scheme) => {
    const curNumCycles =
      scheme.sets.length > 0
        ? Math.max(...scheme.sets.map((s) => s.cycleIndex), 0) + 1
        : 0;
    return (
      (trainingTypeId ? scheme.trainingTypeId === trainingTypeId : true) &&
      (searchTerm ? scheme.name.toLowerCase().includes(search) : true) &&
      (focusIds.length
        ? scheme.focuses.some((focus) => focusIds.includes(focus.focusId))
        : true) &&
      (numOfCycles ? curNumCycles === numOfCycles : true)
    );
  });
};
